import React, { useCallback } from "react";
import { FormikNumberInput } from "components/Inputs/FormikInputs/FormikNumberInput";
import { Field, useFormikContext } from "formik";

export const TableRow = ({ rowData, rowsCount, parentId }) => {
  const { setFieldValue } = useFormikContext();

  const rowTitle = rowData.values[0]?.fieldValue;
  const rowDescription = rowData.values[0]?.description;
  const inputs = rowData.values.slice(rowsCount - 1);

  const onChange = useCallback(
    (e) => {
      const { name, value } = e.target;
      setFieldValue(name, value);
    },
    [setFieldValue],
  );

  return (
    <tr>
      <td>
        <div className="fs-md">{rowTitle}</div>
        <div className="text-gray-400">{rowDescription}</div>
      </td>
      <td className="fs-md">{rowData.values[1]?.fieldValue}</td>
      <td>
        {inputs.map(
          ({ fieldKey, fieldMin, fieldMax, title, fieldType }, key) => (
            <Field
              component={FormikNumberInput}
              classNames={key !== inputs.length - 1 && "mb-2_5"}
              key={fieldKey}
              label={title}
              name={`${parentId.replace(".", ",")}/#${fieldKey}/#${fieldType}`}
              max={fieldMax}
              min={fieldMin}
              onChange={onChange}
            />
          ),
        )}
      </td>
    </tr>
  );
};
